import type { UploadProgress } from '@/types/poc/helia';

export interface UploadProgressLookup {
  uploadId: string;
  fileName: string;
  progress: number;
}

export function findUploadEntryByCid(
  uploadProgress: Record<string, UploadProgress>,
  cid: string
): UploadProgressLookup | undefined {
  const entry = Object.values(uploadProgress).find((progressEntry) => progressEntry.cid === cid);

  if (entry === undefined) {
    return undefined;
  }

  return {
    uploadId: entry.uploadId,
    fileName: entry.fileName,
    progress: entry.progress,
  };
}
